import React, { useState, useEffect } from 'react';
import { IoMusicalNotes, IoSearchOutline } from 'react-icons/io5';
import '../style/Search.css';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import { IoIosArrowBack } from 'react-icons/io';
import Spinner from 'react-bootstrap/Spinner';
import { fetchWithAuth } from './authService';
import { API_ENDPOINTS } from '../utils/constants';
import InsufficientCoinsModal from './InsufficientCoinsModal';

const Search = () => {
  const [AllSongs, setAllSongs] = useState([]);
  const [AllAlbums, setAlbums] = useState([]);
  const [SearchResult, setSearchResult] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [songCost, setSongCost] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [songQuery, setSongQuery] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [price, setPrice] = useState();
  const cancelMsg = () => {
    setIsError(false);
  };
  const [songToAdd, setSongToAdd] = useState(null);
  const navigate = useNavigate();
  const venueId = localStorage.getItem('venueId');
  const [profile, setprofile] = useState({});
  // ...existing code...
  const [showInsufficient, setShowInsufficient] = useState(false);
  useEffect(() => {
    if (isError) {
      const timeout = setTimeout(() => {
        cancelMsg(); // Set isError to false
      }, 4000);
      return () => clearTimeout(timeout);
    }
  }, [isError]);

  const toggleModal = () => {
    setConfirmModal(!confirmModal);
  };
  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }

      //   console.log(token);

      try {
        const response = await fetchWithAuth(API_ENDPOINTS.USERS, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) throw new Error('Failed to fetch data');

        const data = await response.json();
        // console.log(data);
        setprofile(data);
      } catch (error) {
        console.error('Error fetching songs:', error);
      }
    };

    fetchProfile();
  }, []);
  const fetchPrice = async () => {
    try {
      const response = await fetchWithAuth(
        API_ENDPOINTS.ORDER_PRICE_BY_VENUE(localStorage.getItem('vId'))
      );
      if (!response.ok) throw new Error('Failed to fetch price');

      const data = await response.json();
      // Filter out hidden packs
      const visiblePacks = data.filter(pack => !pack.isHidden);
      setPrice(visiblePacks);
    } catch (error) {
      console.error('Error fetching prices:', error);
    }
  };
  useEffect(() => {
    fetchPrice();
  }, []);
  const openConfirm = song => {
    const venueId = localStorage.getItem('vId');
    if (!venueId) {
      setConfirmModal(false);
      setIsError(true);
      setErrorMsg('No Venue Selected..');
      return;
    }
    const cost = localStorage.getItem('songCost');
    if (!cost) {
      // console.error("No cost found");
      return;
    }
    setSongCost(cost);
    setSongToAdd(song);

    if (profile.coins < cost) {
      navigate('/insufficient-coins', {
        state: {
          song,
          cost,
          priceData: price,
          walletCoins: profile.coins,
        },
      });
    } else {
      setConfirmModal(true);
    }
  };
  // ...existing code...

  const cancelConfirm = song => {
    setSongToAdd([]);
    setConfirmModal(false);
  };
  const onAddSong = async (trackId, songName) => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem('tringAuthToken');
      if (!token) {
        console.error('No auth token found');
        return;
      }
      if (!venueId) {
        console.error('No venue token found');
        return;
      }

      // console.log(venueId);
      // console.log(token);
      // console.log(trackId);
      if (localStorage.getItem('shoutout') === 'true') {
        localStorage.setItem('shouttrackId', trackId);
        navigate('/shoutout');

        return;
      }

      const addResponse = await fetchWithAuth(
        API_ENDPOINTS.VENUE_QUEUE(venueId),
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            trackId: trackId,
          }),
        }
      );

      if (!addResponse.ok) {
        const errorData = await addResponse.json(); // try to parse the error message
        const errormsg =
          errorData?.message || errorData?.error || 'Something went wrong';
        setIsLoading(false);
        setErrorMsg(errormsg.toString());
        setIsError(true);
        setConfirmModal(false);
        return;
      }
      if (addResponse.status === 204) {
        localStorage.setItem('notif', true);
        setIsLoading(false);
        setConfirmModal(false);
        setSongToAdd([]);
        // alert("Successfully requested Song");
        navigate(`/venues/${venueId}`);
        return;
      }
    } catch (error) {
      console.error('Error requesting songs:', error);
      alert(error);
    }
  };

  const navigateAlbum = (id, url, name) => {
    localStorage.setItem('playlistImg', url);
    localStorage.setItem('playlistname', name);
    navigate(`/playlist?pid=${id}`);
  };

  const onChangeSearch = async e => {
    const query = e.target.value.trim();
    setSongQuery(query);
    if (!query) {
      setSearchResult([]);
      return;
    }

    const token = localStorage.getItem('tringAuthToken');
    if (!token) {
      console.error('No auth token found');
      return;
    }

    //   console.log(token);

    try {
      const response = await fetchWithAuth(
        `${API_ENDPOINTS.TRACK_SEARCH}?query=${encodeURIComponent(query)}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) throw new Error('Failed to fetch data');

      const data = await response.json();
      setSearchResult(data);
    } catch (error) {
      console.error('Error fetching songs:', error);
    }
  };

  useEffect(() => {
    if (songQuery === '') {
      setSearchResult([]);
    }
  }, []);

  useEffect(() => {
    const fetchAlbums = async () => {
      try {
        const response = await fetchWithAuth(API_ENDPOINTS.PLAYLISTS);

        if (!response.ok) throw new Error('Failed to fetch data');

        const data = await response.json();
        // console.log(data);
        setAlbums(data);

        const songsresp = await fetchWithAuth(
          `${API_ENDPOINTS.TRACK_TRENDING}?venueId=${venueId}`
        );

        if (!songsresp.ok) throw new Error('Failed to fetch data');

        const songsdata = await songsresp.json();
        // console.log(songsdata);
        setAllSongs(songsdata);
      } catch (error) {
        console.error('Error fetching songs:', error);
      }
    };

    fetchAlbums();
  }, []);

  function goBack() {
    window.history.back();
  }

  const excludedLabelsRaw = localStorage.getItem('excludedLabels');
  let excludedLabels = [];

  if (excludedLabelsRaw) {
    try {
      excludedLabels = JSON.parse(excludedLabelsRaw);
    } catch {
      excludedLabels = excludedLabelsRaw.split(',').map(l => l.trim());
    }
  }

  return (
    <div
      className="w-100"
      style={{
        overflow: 'scroll',
        scrollBehavior: 'smooth',
        position: 'relative',
        height: '100vh',
      }}
    >
      {isError && (
        <div
          style={{
            position: 'fixed',
            bottom: '80px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 10000,
            color: '#FFFFFF',
            background: 'rgb(32, 32, 32)',
            borderRadius: '4px',
            boxShadow: '0 4px 12px rgba(32, 32, 32, 0.73)',
            padding: '16px 24px',
            minWidth: '95vw',
            maxWidth: '95vw',
            animation: 'slideDown 0.4s cubic-bezier(0.18, 0.89, 0.32, 1.28)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '12px',
          }}
        >
          <span
            style={{
              flex: 1,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              textAlign: 'start',
            }}
          >
            {typeof errorMsg === 'string'
              ? errorMsg
              : errorMsg?.message || 'Something went wrong'}
          </span>

          {errorMsg === 'No Venue Selected..' && (
            <button
              style={{
                flexShrink: 0,
                padding: '4px 8px',
                backgroundColor: 'rgb(211, 64, 64)',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                fontSize: '13px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
              }}
              onClick={() => {
                localStorage.setItem('mainInd', 1);
                window.location.reload();
              }}
            >
              Select Venue
            </button>
          )}
        </div>
      )}
      {isLoading ? (
        <div className="lmodale">
          <div className="loverlay"></div>

          <div className="lmodalecontent">
            <Spinner animation="border" role="status" style={{ color: 'red' }}>
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      ) : (
        <div></div>
      )}
      <div
        className="p-2"
        style={{
          position: 'sticky',
          background: 'white',
          top: 0,
          zIndex: 100,
        }}
      >
        <div className="d-flex flex-row justify-content-start align-items-center col-12 ">
          <IoIosArrowBack
            className="mb-2 "
            style={{
              fontSize: '32px',
              marginRight: '7px',
              marginLeft: '-5px',
              color: 'black',
            }}
            onClick={() => goBack()}
          />
          <div
            className="d-flex flex-row align-items-center px-2 py-1 mb-2 "
            style={{
              gap: '15px',
              borderRadius: '10px',
              border: '1px solid #C3C0C0',
              fontSize: '20px',
              flexGrow: 1,
            }}
          >
            <IoSearchOutline className="mt-1" />
            <input
              type="text"
              style={{
                border: 'none',
                background: 'transparent',
                outline: 'none',
              }}
              onChange={onChangeSearch}
              placeholder="Search for a song..."
              className=" text-start"
            />
          </div>
        </div>
      </div>
      {confirmModal ? (
        <div className="modale position-relative">
          <div className="overlay" onClick={() => cancelConfirm()}></div>

          <div className="modale-content">
            <div
              className="w-100 p-3 d-flex flex-row"
              style={{
                borderRadius: '15px 15px 0px 0px',
                background: 'linear-gradient(90deg, #C91721 0%, #8A325D 100%)',
              }}
            >
              <div className="col-3"></div>
              <div className=" col-9 d-flex flex-row justify-content-between">
                <h4 className="m-0" style={{ color: 'white' }}>
                  Song Request
                </h4>

                <button
                  className=""
                  style={{
                    color: 'white',
                    background: 'transparent',
                    border: 'none',
                  }}
                  onClick={() => cancelConfirm()}
                >
                  <IoMdCloseCircleOutline
                    style={{ color: 'white', fontSize: '25px' }}
                  />{' '}
                </button>
              </div>
            </div>

            {songToAdd ? (
              <div className="w-100">
                <div
                  className="px-3 w-100"
                  style={{ background: '#FFF', padding: '15px 0px 15px 0px' }}
                >
                  <div className="d-flex flex-row justify-content-between align-items-center">
                    <div
                      className="d-flex flex-row align-items-center"
                      style={{ gap: '15px' }}
                    >
                      <img
                        src={songToAdd.album.images[0].url}
                        style={{
                          height: '60px',
                          width: '60px',
                          borderRadius: '50%',
                        }}
                      />
                      <span
                        style={{
                          color: '#9F2A4A',
                          fontSize: 'clamp(0px,4vw,16px)',
                        }}
                        className="text-start col-8"
                      >
                        {songToAdd.name}
                      </span>
                    </div>

                    {localStorage.getItem('shoutout') !== 'true' && (
                      <div>
                        <img
                          src="/images/coin.svg"
                          style={{
                            width: 'clamp(0px,5vw,20px)',
                            aspectRatio: '1/1',
                          }}
                        />
                        <h4
                          style={{
                            color: '#9F2A4A',
                            fontSize: 'clamp(0px,4vw,16px)',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {songCost} coin
                        </h4>
                      </div>
                    )}
                  </div>
                </div>

                <div className="d-flex flex-row justify-content-between align-items-center w-100">
                  <button
                    className="col-6 p-2"
                    style={{
                      background: '#FFF',
                      color: '#C71823',
                      border: 'solid .5px #C71823',
                      borderRadius: '0px 0px 0px 15px',
                      fontSize: '18px',
                    }}
                    onClick={() => cancelConfirm()}
                  >
                    Cancel
                  </button>

                  <button
                    className="col-6 p-2"
                    style={{
                      background:
                        'linear-gradient(90deg, #CC151E -18.35%, #873662 108.23%)',
                      color: 'white',
                      border: 'solid .5px #C71823',
                      borderRadius: '0px 0px 15px 0px',
                      fontSize: '18px',
                    }}
                    onClick={() => onAddSong(songToAdd.id, songToAdd.name)}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            ) : (
              <div>Just a sec</div>
            )}
          </div>
        </div>
      ) : (
        <div></div>
      )}
      {SearchResult.length === 0 ? (
        <div
          style={{
            overflow: 'scroll',
            scrollBehavior: 'smooth',
            position: 'relative',
            height: '100vh',
          }}
        >
          <div className="w-100">
            <h4
              className="mb-2 mt-2 mx-2 text-start"
              style={{ fontWeight: 550 }}
            >
              Songs for You
            </h4>

            {AllSongs.map((song, index) => {
              const isExcluded =
                song?.label && excludedLabels?.includes(song.label);
              return (
                <div
                  onClick={() => {
                    if (isExcluded) {
                      setErrorMsg('This song is available in this venue.');
                      setIsError(true);
                    } else {
                      openConfirm(song);
                    }
                  }}
                  key={index}
                >
                  <div className="mb-0">
                    <div className="d-flex flex-row justify-content-start align-items-center">
                      <img
                        className="mx-2"
                        style={{
                          height: '50px',
                          width: '50px',
                          borderRadius: '50%',
                        }}
                        src={
                          song?.album?.images[0]?.url ||
                          song?.album?.images[1]?.url ||
                          song?.album?.images[2]?.url
                        }
                      />

                      <div
                        className="d-flex flex-column px-1 text-start overflow-hidden mx-1"
                        style={{
                          gap: '5px',
                          width: '50%',
                          fontSize: '5vw',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <h6 className="text-start col-7 mb-0">{song?.name}</h6>
                        <div
                          className="w-100 overflow-hidden d-flex flex-row justify-content-start align-items-center"
                          style={{ gap: '3px' }}
                        >
                          {song?.artists.slice(0, 2).map((artist, index) => (
                            <span
                              className="text-start overflow-hidden common-txt"
                              key={index}
                              style={{
                                fontSize: 'clamp(0px,3.3vw,15px)',
                                whiteSpace: 'nowrap',
                                color: 'gray',
                                maxWidth: '40%',
                              }}
                            >
                              {artist?.name} ,
                            </span>
                          ))}
                          {song?.artists?.length > 2 && (
                            <div
                              style={{
                                aspectRatio: '1/1',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: 'clamp(0px,3.3vw,12px)',
                                color: 'gray',
                              }}
                            >
                              +{song?.artists?.length - 2}
                            </div>
                          )}
                        </div>
                      </div>

                      <div
                        className="d-flex justify-content-end flex-row"
                        style={{ flexGrow: 1 }}
                      >
                        <button
                          className="mx-2 px-4 py-2 my-2"
                          style={{
                            color: 'white',
                            border: 'none',
                            background: isExcluded
                              ? 'gray'
                              : 'linear-gradient(90deg, #D51217 0%, #843866 100%)',
                            height: 'fit-content',
                            fontSize: 'clamp(0px,3.5vw,17px)',
                            whiteSpace: 'nowrap',
                            borderRadius: '15px',
                            cursor: isExcluded ? 'not-allowed' : 'pointer',
                            opacity: isExcluded ? 0.6 : 1,
                          }}
                          onClick={() => {
                            if (isExcluded) {
                              setErrorMsg(
                                'This song is available in this venue.'
                              );
                              setIsError(true);
                            } else {
                              openConfirm(song);
                            }
                          }}
                        >
                          {'+ Add'}
                        </button>
                      </div>
                    </div>
                    <hr className="my-2" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <div
          style={{
            overflow: 'scroll',
            scrollBehavior: 'smooth',
            position: 'relative',
            height: '100vh',
          }}
        >
          {SearchResult.tracks.map((song, index) => {
            // check if song should be excluded
            const isExcluded =
              song?.label && excludedLabels?.includes(song.label);
            return (
              <div
                onClick={() => {
                  if (isExcluded) {
                    setErrorMsg('This song is not available in this venue.');
                    setIsError(true);
                  } else {
                    openConfirm(song);
                  }
                }}
                key={index}
              >
                <div className="mb-0">
                  <div className="d-flex flex-row justify-content-start align-items-center">
                    <img
                      className="mx-2"
                      style={{
                        height: '50px',
                        width: '50px',
                        borderRadius: '50%',
                      }}
                      src={
                        song?.album?.images[0]?.url ||
                        song?.album?.images[1]?.url ||
                        song?.album?.images[2]?.url
                      }
                    />

                    <div
                      className="d-flex flex-column px-1 text-start overflow-hidden mx-1"
                      style={{
                        gap: '5px',
                        width: '50%',
                        fontSize: '5vw',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <h6 className="text-start col-7 mb-0">{song?.name}</h6>
                      <div
                        className="w-100 overflow-hidden d-flex flex-row justify-content-start align-items-center"
                        style={{ gap: '3px' }}
                      >
                        {song?.artists.slice(0, 2).map((artist, index) => (
                          <span
                            className="text-start overflow-hidden common-txt"
                            key={index}
                            style={{
                              fontSize: 'clamp(0px,3.3vw,15px)',
                              whiteSpace: 'nowrap',
                              color: 'gray',
                              maxWidth: '40%',
                            }}
                          >
                            {artist?.name} ,
                          </span>
                        ))}
                        {song?.artists?.length > 2 && (
                          <div
                            style={{
                              aspectRatio: '1/1',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: 'clamp(0px,3.3vw,12px)',
                              color: 'gray',
                            }}
                          >
                            +{song?.artists?.length - 2}
                          </div>
                        )}
                      </div>
                    </div>

                    <div
                      className="d-flex justify-content-end flex-row"
                      style={{ flexGrow: 1 }}
                    >
                      <button
                        className="mx-2 px-4 py-2 my-2"
                        style={{
                          color: 'white',
                          border: 'none',
                          background: isExcluded
                            ? 'gray'
                            : 'linear-gradient(90deg, #D51217 0%, #843866 100%)',
                          height: 'fit-content',
                          fontSize: 'clamp(0px,3.5vw,17px)',
                          whiteSpace: 'nowrap',
                          borderRadius: '15px',
                          cursor: isExcluded ? 'not-allowed' : 'pointer',
                          opacity: isExcluded ? 0.6 : 1,
                        }}
                        onClick={() => {
                          if (isExcluded) {
                            setErrorMsg(
                              'This song is not available in this venue.'
                            );
                            setIsError(true);
                          } else {
                            openConfirm(song);
                          }
                        }}
                      >
                        {'+ Add'}
                      </button>
                    </div>
                  </div>
                  <hr className="my-2" />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Search;
